import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';

import style from './remove-from-batch-button.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

const RemoveFromBatchButton = (props) => {
  const { onClick = noop, disabled = false, fulfillmentPlanSetId = '', selectedGridFulfillmentPlanIds = emptyArray } = props;
  return (
    <Button
      className={style['remove-from-batch-button']}
      disabled={disabled}
      onClick={() => {
        onClick(fulfillmentPlanSetId, selectedGridFulfillmentPlanIds);
      }}
      theme='tertiary'
    >
      <FormattedMessage defaultMessage='Remove from Batch' description='batch.details.removeFromBatch' id='pFKIdI' />
    </Button>
  );
};

RemoveFromBatchButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  fulfillmentPlanSetId: PropTypes.string,
  selectedGridFulfillmentPlanIds: PropTypes.arrayOf(PropTypes.string),
};

export default RemoveFromBatchButton;
